<script>
    import { Icon } from 'sveltestrap';

    export let name;
    export let order;
    export let direction;
</script>

{#if order == name}
    {#if direction == "desc"}
        <Icon name="caret-down-fill" />
    {:else}
        <Icon name="caret-up-fill" />
    {/if}
{/if}